/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookTimeThreeDsGateRequest
 */
export interface BookTimeThreeDsGateRequest {
    /**
     * Gondola PaymentMethod UUID the booking is about to charge.
     * @type {string}
     * @memberof BookTimeThreeDsGateRequest
     */
    paymentMethodId: string;
    /**
     * The caller's client can render a Stripe 3DS challenge. When true, a challenge-routed verification returns the SetupIntent `client_secret` (instead of a dead-end refusal) so the client can run the challenge and retry the booking — the retry re-reads the intent server-side and is the completion signal.
     * 
     * @type {boolean}
     * @memberof BookTimeThreeDsGateRequest
     */
    supportsThreeDsChallenge?: boolean;
    /**
     * Demand a 3DS pass regardless of account age. Set by api_search for LiteAPI-backed bookings, where Gondola is merchant of record and therefore eats the chargeback; every confirmed-fraud booking to date has been LiteAPI. Service-to-service only — never forwarded from a client. api_search derives it from `rate_type`, which IS client-supplied, but the derivation is still not a usable opt-out: the same field routes the booking, so declaring a non-LiteAPI rate type to dodge this sends the request to the direct/Travelport processor and the LiteAPI booking never happens. When true the gate skips its `account_established` shortcut; every other branch is unchanged, so a card that already carries an accepted 3DS record still returns `already_verified` and the customer sees no repeat challenge.
     * 
     * @type {boolean}
     * @memberof BookTimeThreeDsGateRequest
     */
    requireThreeDs?: boolean;
}

/**
 * Check if a given object implements the BookTimeThreeDsGateRequest interface.
 */
export function instanceOfBookTimeThreeDsGateRequest(value: object): value is BookTimeThreeDsGateRequest {
    if (!('paymentMethodId' in value) || value['paymentMethodId'] === undefined) return false;
    return true;
}

export function BookTimeThreeDsGateRequestFromJSON(json: any): BookTimeThreeDsGateRequest {
    return BookTimeThreeDsGateRequestFromJSONTyped(json, false);
}

export function BookTimeThreeDsGateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookTimeThreeDsGateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethodId': json['payment_method_id'],
        'supportsThreeDsChallenge': json['supports_three_ds_challenge'] == null ? undefined : json['supports_three_ds_challenge'],
        'requireThreeDs': json['require_three_ds'] == null ? undefined : json['require_three_ds'],
    };
}

export function BookTimeThreeDsGateRequestToJSON(json: any): BookTimeThreeDsGateRequest {
    return BookTimeThreeDsGateRequestToJSONTyped(json, false);
}

export function BookTimeThreeDsGateRequestToJSONTyped(value?: BookTimeThreeDsGateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method_id': value['paymentMethodId'],
        'supports_three_ds_challenge': value['supportsThreeDsChallenge'],
        'require_three_ds': value['requireThreeDs'],
    };
}

